import { CMS_LIST } from "../../store/actionTypes";

const initial = {};

/**
 * 
 * @param {initial state of reducer} state 
 * @param { perfoam actions } action 
 * @returns update state of reducer
 */

const CmsReducer = (state = initial, action) => {
  switch (action.type) {
    case CMS_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};

export default CmsReducer;